/* Snaps the theme's horizontal hairlines onto the body's 28px background grid
   so a dark rule never sits a few pixels off a faint gridline (which reads as a
   doubled line). The grid is painted from the top of the page, so we measure
   each rule's document-Y and nudge it to the nearest grid row via margin-top.

   Three kinds of rule are snapped, all handled the same way — measure an edge,
   move a "nudge" element by the delta to the nearest grid line:
     • .isotope-catalog__note — border-top above the commitment note
     • .isotope-masthead::after — the rule the filter tabs sit flush on; can't
       target a pseudo-element, so we snap the filters block's bottom edge (the
       rule sits at the masthead's bottom, which is the filters' bottom)
     • .iso-cluster-head — each section header's __line

   Rules are processed top-to-bottom because nudging one shifts everything below
   it; each later rule is measured after the earlier nudges are applied. */
(function () {
  function gridSize() {
    var size = parseFloat(getComputedStyle(document.body).backgroundSize);
    return size > 0 ? size : 28;
  }

  /* Build the list of { measure, edge, nudge } targets present on the page. */
  function collect() {
    var list = [];

    var note = document.querySelector('.isotope-catalog__note');
    // Snap the note's rule to the grid line *below* its natural spot so the
    // hairline keeps a full cell of breathing room from the paragraph above
    // (snapping up would jam it against the last line of the lead copy).
    if (note) list.push({ measure: note, edge: 'top', nudge: note, round: Math.ceil });

    var filters = document.querySelector('.isotope-filters');
    if (filters) list.push({ measure: filters, edge: 'bottom', nudge: filters });

    document.querySelectorAll('.iso-cluster-head').forEach(function (head) {
      var line = head.querySelector('.iso-cluster-head__line');
      if (line) list.push({ measure: line, edge: 'top', nudge: head });
    });

    return list;
  }

  function docY(el, edge) {
    var r = el.getBoundingClientRect();
    return (edge === 'bottom' ? r.bottom : r.top) + window.pageYOffset;
  }

  function snap() {
    var list = collect();
    if (!list.length) return;
    var size = gridSize();

    /* Clear previous nudges so measurements start from the natural layout. */
    list.forEach(function (t) { t.nudge.style.marginTop = ''; });

    /* Order top-to-bottom by natural position, then snap in that order so each
       nudge is reflected in the next target's measurement. */
    list.sort(function (a, b) {
      return docY(a.measure, a.edge) - docY(b.measure, b.edge);
    });

    list.forEach(function (t) {
      if (!t.measure.offsetParent) return; // hidden (e.g. group filtered out)
      var round = t.round || Math.round;
      var base = parseFloat(getComputedStyle(t.nudge).marginTop) || 0;
      var y = docY(t.measure, t.edge);
      var delta = round(y / size) * size - y;
      // Add to the element's own base margin rather than replacing it.
      if (Math.abs(delta) > 0.5) t.nudge.style.marginTop = (base + delta) + 'px';
    });
  }

  var raf;
  function queue() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(snap);
  }

  document.addEventListener('DOMContentLoaded', queue);
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);

  // Filter tabs show/hide whole groups, which moves every rule below them.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.isotope-filters__tab')) queue();
  });

  queue();
})();
